module.exports = __webpack_public_path__ + "static/media/2.5 Heeremans nach.718264fc.jpg";